import { useTranslation } from "react-i18next";

import { WarningModal } from "#components/molecules/Modal/WarningModal";

type Props = {
  opened: boolean;
  isConfirming?: boolean;
  onConfirm: () => void;
  onKeepEditing: () => void;
};

export const CancelOptimizationModal = ({
  opened,
  isConfirming = false,
  onConfirm,
  onKeepEditing,
}: Props) => {
  const { t } = useTranslation();

  return (
    <WarningModal
      opened={opened}
      title={t("optimizations.detail.cancel.title")}
      description={t("optimizations.detail.cancel.description")}
      primaryText={t("optimizations.detail.cancel.confirm")}
      secondaryText={t("optimizations.detail.cancel.keepEditing")}
      closeText={t("common.close")}
      primaryLoading={isConfirming}
      onPrimary={onConfirm}
      onSecondary={onKeepEditing}
      onClose={onKeepEditing}
    />
  );
};
